// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `angular-cli.json`.

export const environment = {
  production: false,
  apiEndPoint : 'https://bodes-api.azurewebsites.net/api',
  callbackURL : [
    'http://localhost:8080/#/callback/super',
    'http://localhost:8080/#/callback/ahm',
    'http://localhost:8080/#/callback/ho-management',
    'http://localhost:8080/#/callback/ho-marketing',
    'http://localhost:8080/#/callback/md-management',
    'http://localhost:8080/#/callback/md-staff',
    'http://localhost:8080/#/callback/dealer'
  ],
  allowedExtensionUpload: ['.xlsx']
};



// WEBPACK FOOTER //
// /Users/muhammadfiqihfirdiansyah/Documents/Muhammad Fiqih Firdiansyah/Project/Angular/BODES/BODES.Web.UI.Angular4/src/environments/environment.ts